import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { getErrorText } from 'src/app/service/ansokan-form-builder/validator-errors';

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    standalone: false
})
export class SelectComponent implements OnInit {

  private static ID = 0;
  @Input() public control: UntypedFormControl;
  @Input() public label: string;
  @Output() public valueChange: EventEmitter<string> = new EventEmitter<string>();
  public localGroup: UntypedFormGroup;
  public id: string;

  constructor(private fb: UntypedFormBuilder) {
    this.id = 'select-component-' + (SelectComponent.ID++);
  }

  public ngOnInit() {
    this.localGroup = this.fb.group({ control: this.control });
  }

  public get error(): string {
    return this.control ? getErrorText(this.control) : null;
  }

  public get classes() {
    return {
      'icon-dropdown-arrow': true,
      'skv-form-control': true,
      'skv-form-control--error icon-error': this.control && this.control.invalid && this.control.touched,
    };
  }

  public onChange(event: Event): void {
    const element: HTMLSelectElement = event.target as HTMLSelectElement;
    // Lose focus.
    element.blur();
    // Emit value change event.
    this.valueChange.emit(element.value);
  }
}
